import { BaseService } from 'core/common/services';
import { Offer, ContentOffer, StrictOffersMapByCategory, OfferContentBase } from '../../entities';
import { OfferMapper } from '../../mappers';
import { OfferDto } from '../dto';

export class OffersService extends BaseService {
  async getOffers(offerIds: string[]): Promise<Offer[]> {
    const mapper = new OfferMapper();

    if (!offerIds.length) {
      return [];
    }

    const { data } = await this.httpClient.get<OfferDto[]>(
      '/products/list?filter[ids]=' + offerIds.join(','),
    );

    return data.map(mapper.toEntity);
  }

  getOffersMap(offer: StrictOffersMapByCategory, contentOffer?: ContentOffer) {
    const mapper = new OfferMapper();

    return mapper.mapContentOffersToOffers(offer, contentOffer);
  }

  matchOffersWithContent<TContent extends OfferContentBase>(
    offers: Offer[],
    contentOffers?: Array<TContent>,
  ) {
    const mapper = new OfferMapper();

    return mapper.matchOffersWithContent(offers, contentOffers);
  }
}
